import styled from 'styled-components';

export const _CheckboxWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  font-family: ${(props) => props.theme.fontFamilyPrimary};
  margin-bottom: 16px;
  font-size: 18px;

  div {
    display: flex;
    align-items: center;

    label {
      float: none; // Scensum override
      height: 22px;
    }

    input[type='checkbox'] {
      cursor: pointer;
      accent-color: ${(props) => props.theme.black};
      margin: 4px 8px 4px 0px;
      height: 22px;
      width: 22px;
      border-width: 5px;
    }
  }

  :has(#tacCheckbox) {
    margin-bottom: 20px;
  }

  .tacText {
    margin-left: 8px;

    p {
      margin: 0;
    }
  }

  input#tacCheckbox[type='checkbox'] {
    appearance: none;
    background-color: #fff;
    margin: 0;
    font: inherit;
    color: currentColor;
    width: 20px;
    height: 20px;
    border: 1px solid ${(props) => props.theme.black};
    border-radius: none;
    display: grid;

    &::before {
      content: '\\2713';
      width: 22px;
      height: 42px;
      transform: scale(0);
      transition: 120ms transform ease-in-out;
      color: ${(props) => props.theme.primary};
      justify-self: center;
    }

    &:checked::before {
      transform: scale(2.3);
      padding-left: 6px;
      padding-bottom: 4px;
    }
  }
`;
